import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./userReducer.js";
import busySlice from "./busyReducer.js";
import statusCode from "./statusCodeReducer.js";

const store = configureStore({
  reducer: { user: userSlice, busy: busySlice, statusCode },
});

export default store;
